<template>
    <div class="m-pop">
        <div class="pop-mask"></div>
        <div class="pop-con">
            <div class="title">
                <h3>用户注册</h3>
                <div class="close" @click="close">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="form">
                <div class="username-tips" v-if="showUsernameWarning">
                    <i class="el-icon-warning-outline"></i>
                    禁止使用此类型用户名！
                </div>
                <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
                    <el-form-item prop="nickname" label="用户名">
                        <el-input
                            v-model="registerForm.nickname"
                            name="username"
                            autocomplete="username"
                            prefix-icon="el-icon-user-solid"
                            placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item prop="mobile" label="手机号">
                        <el-input
                            v-model="registerForm.mobile"
                            name="mobile"
                            autocomplete="tel"
                            prefix-icon="el-icon-mobile-phone"
                            placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item prop="password" label="密码">
                        <el-input
                            v-model="registerForm.password"
                            name="password"
                            autocomplete="new-password"
                            prefix-icon="el-icon-lock"
                            type="password" placeholder="请设置密码（至少6位）"></el-input>
                    </el-form-item>
                    <el-form-item prop="confirmPassword" label="确认密码">
                        <el-input 
                            v-model="registerForm.confirmPassword"
                            name="confirmPassword"
                            autocomplete="new-password"
                            type="password"
                            prefix-icon="el-icon-lock"
                            placeholder="请再次输入密码"></el-input>
                    </el-form-item>
                </el-form>
                <el-button type="primary" class="submit-btn" @click="handleRegister">注册</el-button>
                <div class="tips">
                    已有账号？<span @click="openLogin">立即登录</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    data() {
        // 禁止的用户名列表
        const forbiddenUsernames = [
            // 管理权限类
            'admin', 'administrator', 'root', 'system', 'moderator',
            // 平台功能类
            'help', 'support', 'webmaster', 'service', 'api',
            // 测试演示类
            'test', 'demo', 'guest', 'example',
            // 数据库保留字
            'master', 'sys', 'dbo', 'dba', 'public',
            // 平台专属标识
            'steam', 'douyu', 'weixin', 'tencent'
        ]
        
        // 用户名校验规则
        const validateUsername = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入用户名'))
            } else if (value.length < 3 || value.length > 20) {
                callback(new Error('用户名长度在 3 到 20 个字符'))
            } else if (forbiddenUsernames.includes(value.toLowerCase())) {
                callback(new Error('该用户名不可使用，请更换其他用户名'))
            } else {
                callback()
            }
        }
        
        // 密码校验规则
        const validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'))
            } else if (value.length < 6) {
                callback(new Error('密码长度不能小于6位'))
            } else {
                if (this.registerForm.confirmPassword !== '') {
                    this.$refs.registerForm.validateField('confirmPassword')
                }
                callback()
            }
        }
        
        // 确认密码校验规则
        const validateConfirmPassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.registerForm.password) {
                callback(new Error('两次输入密码不一致'))
            } else {
                callback()
            }
        }
        
        return {
            forbiddenUsernames,
            registerForm: {
                nickname: '',
                mobile: '',
                password: '',
                confirmPassword: ''
            },
            registerRules: {
                nickname: [
                    { validator: validateUsername, trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                password: [
                    { validator: validatePassword, trigger: 'blur' }
                ],
                confirmPassword: [
                    { validator: validateConfirmPassword, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        showUsernameWarning() {
            if (!this.registerForm.nickname) {
                return false
            }
            return this.forbiddenUsernames.includes(this.registerForm.nickname.toLowerCase())
        }
    },
    methods:{
        ...mapActions(['register', 'getUserInfo']),
        close:function () {
            this.$emit('close')
        },
        openLogin:function () {
            this.$emit('openLogin')
        },
        handleRegister() {
            this.$refs.registerForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const registerData = {
                            nickname: this.registerForm.nickname,
                            password: this.registerForm.password,
                            mobile: this.registerForm.mobile
                        }
                        console.log('注册提交数据:', registerData)
                        console.log('密码值:', this.registerForm.password)
                        console.log('密码长度:', this.registerForm.password.length)
                        await this.register(registerData)
                        // 注册成功后获取最新的用户信息，确保头像等信息是最新的
                        await this.getUserInfo()
                        this.$message.success('注册成功')
                        this.close()
                    } catch (error) {
                        console.error('注册失败:', error)
                        console.error('错误详情:', error.response)
                        console.error('错误数据:', error.response?.data)
                        
                        let errorMsg = '注册失败'
                        const errorData = error.response?.data
                        
                        if (errorData && errorData.message) {
                            const message = errorData.message
                            
                            if (message.includes("Duplicate entry") && message.includes("for key 'nickname'")) {
                                errorMsg = '该用户名已被注册，请更换用户名'
                            } else if (message.includes("Duplicate entry") && message.includes("for key 'mobile'")) {
                                errorMsg = '该手机号已被注册，请更换手机号'
                            } else if (message.includes('该用户名不可使用')) {
                                errorMsg = '该用户名不可使用，请更换其他用户名'
                            } else {
                                errorMsg = errorData.message
                            }
                        } else {
                            errorMsg = error.message || '注册失败'
                        }
                        
                        this.$message.error(errorMsg)
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>



<style scoped lang="scss">
.username-tips {
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 4px;
    padding: 10px 15px;
    margin-bottom: 20px;
    font-size: 13px;
    color: #856404;
    line-height: 1.5;
    
    i {
        margin-right: 5px;
        font-size: 14px;
    }
}
</style>
